import React, { useCallback, useEffect } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import POChangeRecordsList from "./POChangeRecordsList";
import useActions from "../../../hooks/useActions";
import { initDataComponent } from "../../../../actions/dataComponentActions";
import { getDataComponentFlattenedRequestState } from "../../../../reducers/dataComponentReducer";
import PurchaseOrderChangeRecords from "../../../../models/PurchaseOrderChangeRecords";
import propTypes from "../../../../constants/propTypes";
import { useUserRoleCan } from "../../../hooks/useUserRole";

export const dataComponentId = "POChangeRecordsGrid";

const POChangeRecordsContainer = ({ purchaseOrder }) => {
  const { poId } = useParams();

  // Permission gate - return null if user doesn't have permission
  const canViewChangeRecords = useUserRoleCan(
    "view-purchase-order-change-records"
  );

  const actions = useActions({
    initDataComponent,
  });

  // Initialize data component on mount
  useEffect(() => {
    actions.initDataComponent(
      dataComponentId,
      PurchaseOrderChangeRecords,
      ["user.person"], // Include user and person who made the change
      "purchase-order-change-records",
      true, // API-driven
      "v2" // Use v2 API
    );
  }, [actions]);

  // Get flattened data component state from Redux
  const { flattenedDataComponent } = useSelector(state => ({
    flattenedDataComponent: getDataComponentFlattenedRequestState(
      dataComponentId,
      state
    ),
  }));

  // Row click handler
  const handleRowClick = useCallback(() => {
    // TODO: Implement if change records have detail views
  }, []);

  // Permission gate - hide entire component if no permission
  if (!canViewChangeRecords) return null;

  return (
    <POChangeRecordsList
      dataComponent={flattenedDataComponent}
      poId={poId}
      onRowClick={handleRowClick}
      changeRecordsCount={purchaseOrder.changeRecordsCount || 0}
    />
  );
};

POChangeRecordsContainer.propTypes = {
  purchaseOrder: propTypes.purchaseOrder.isRequired,
};

export default POChangeRecordsContainer;
